import React from 'react'
import Modal from '@mui/material/Modal'
import Box from '@mui/material/Box'
import { t } from 'i18next'
import yappyIcon from 'Assets/Images/PaymentMethods/yappy.svg'
import { Formatter } from 'Utils/Formatter'
import './YappyPaymentConfirmationModal.css'

function YappyPaymentConfirmationModal({
  open,
  onClose,
  clientName,
  email,
  phone,
  amount,
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="yappy-confirm-modal-title"
      slotProps={{
        backdrop: {
          sx: { backgroundColor: 'rgba(0, 0, 0, 0.2)' },
        },
      }}>
      <Box
        className="yappy-confirm-modal"
        data-testid="modal-yappy-confirmation">
        <div className="yappy-confirm-modal__header">
          <h2
            id="yappy-confirm-modal-title"
            className="yappy-confirm-modal__title">
            {t('YAPPY_CONFIRM_MODAL_T.TITLE')}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="yappy-confirm-modal__close-btn"
            aria-label={t('YAPPY_CONFIRM_MODAL_T.CLOSE_ARIA_LABEL')}
            data-testid="btn-close-yappy-confirm">
            ✕
          </button>
        </div>

        <p className="yappy-confirm-modal__subtitle">
          {t('YAPPY_CONFIRM_MODAL_T.SUBTITLE')}
        </p>

        <div className="yappy-confirm-modal__logo-section">
          <img
            src={yappyIcon}
            alt="Yappy"
            className="yappy-confirm-modal__logo"
          />
          <p className="yappy-confirm-modal__success-text">
            {t('YAPPY_CONFIRM_MODAL_T.SUCCESS_TEXT')}
          </p>
          <p className="yappy-confirm-modal__description">
            {t('YAPPY_CONFIRM_MODAL_T.DESCRIPTION_LINE_1')}
            <br />
            {t('YAPPY_CONFIRM_MODAL_T.DESCRIPTION_LINE_2')}
          </p>
        </div>

        <div className="yappy-confirm-modal__info-card">
          <p className="yappy-confirm-modal__info-card-title">
            {t('YAPPY_CONFIRM_MODAL_T.INFO_CARD_TITLE')}
          </p>

          <div className="yappy-confirm-modal__info-grid">
            <div>
              <p className="yappy-confirm-modal__info-label">
                {t('YAPPY_CONFIRM_MODAL_T.CLIENT_LABEL')}
              </p>
              <p
                className="yappy-confirm-modal__info-value"
                data-testid="yappy-confirm-client-name">
                {clientName || '—'}
              </p>
            </div>

            <div>
              <p className="yappy-confirm-modal__info-label">
                {t('YAPPY_CONFIRM_MODAL_T.EMAIL_LABEL')}
              </p>
              <p
                className="yappy-confirm-modal__info-value"
                data-testid="yappy-confirm-email">
                {email || '—'}
              </p>
            </div>

            <div>
              <p className="yappy-confirm-modal__info-label">
                {t('YAPPY_CONFIRM_MODAL_T.PHONE_LABEL')}
              </p>
              <p
                className="yappy-confirm-modal__info-value"
                data-testid="yappy-confirm-phone">
                {phone || '—'}
              </p>
            </div>

            <hr className="yappy-confirm-modal__info-divider" />

            <div>
              <p className="yappy-confirm-modal__info-label">
                {t('YAPPY_CONFIRM_MODAL_T.AMOUNT_LABEL')}
              </p>
              <p
                className="yappy-confirm-modal__info-value"
                data-testid="yappy-confirm-amount">
                {amount != null ? `$${Formatter.Money(amount)}` : '—'}
              </p>
            </div>
          </div>
        </div>

        <div className="yappy-confirm-modal__footer">
          <button
            type="button"
            onClick={onClose}
            className="yappy-confirm-modal__close-action-btn"
            data-testid="btn-close-yappy-confirm-action">
            {t('YAPPY_CONFIRM_MODAL_T.CLOSE_BUTTON')}
          </button>
        </div>
      </Box>
    </Modal>
  )
}

export default YappyPaymentConfirmationModal
